import {computed, Ref} from 'vue';
import {useDeviceInfo} from '@/hooks/useDeviceInfo';
import useRequest from '.';

const PATH_PREFIX = process.env.NODE_ENV !== 'mock' ? '' : '/information';

// nativeKey
// 与useTopList共用
// tag 标签
// top 置顶
// list 列表
// 所有资讯列表, 资讯的 pager 在 data 中
export const useAllList = (
  pager: ReqPager,
  params: {
    newsCategoryIds: number[];
    areaIdList?: Ref<number[]>;
    h5TagIdList?: number[];
    tagId?: number;
    hasCollectQuery?: 0 | 1;
  },
  nativeKey?: string,
  useNative?: boolean,
  type?: 'immediate' | 'await' | 'manual',
) => {
  const payload = computed(() => ({
    newsCategoryIds: params.newsCategoryIds,
    hasTopData: !params?.hasCollectQuery, // 新置顶, 写死
    deviceId: useDeviceInfo().did, // 设备 id
    appRequest: true, // true-客户端请求
    appType: useDeviceInfo().p_client,
    pager,
    areaIdList: params.areaIdList?.value.map((item: number) => item.toString()), // 地区编码为字符串数组
    h5TagIdList: params.h5TagIdList, // tag 为 number 数组
    tagId: params.tagId, // 当前 active 的 tagId
    hasCollectQuery: params.hasCollectQuery, // 是否请求收藏
  }));
  // 只有地区是全国的时候才能预取
  const area_id_list = localStorage.getItem('area_id_list');
  const usePrefetch = (area_id_list === '[0]' || area_id_list === null) && useNative;

  return useRequest<{
    list: InfoItem[];
    pager: Pager;
  }>({
    method: 'post',
    url: `${PATH_PREFIX}/news/newsList`,
    data: payload.value,
    useNative: usePrefetch,
    nativeKey,
    type,
  });
};

// 重点(置顶)资讯列表
// export const useTopList = (
//   newsCategoryIds: number[],
//   areaIdList: Ref<number[]>,
//   nativeKey?: string,
//   useNative?: boolean,
//   immediate?: boolean,
// ) => {
//   const payload = computed(() => ({
//     newsCategoryIds,
//     hasTop: true, // true-请求资讯置顶列表 false-请求所有资讯列表
//     deviceId: useDeviceInfo().did, // 设备 id
//     appRequest: true, // true-客户端请求
//     appType: useDeviceInfo().p_client,
//     pager: {
//       current: 1,
//       pageSize: 3,

//     },
//     areaIdList: areaIdList.value.map((item: number) => item.toString())// 地区编码为字符串数组
//   }));
//   // 只有地区是全国的时候才能预取
//   const area_id_list = localStorage.getItem('area_id_list');
//   const usePrefetch = (area_id_list === '[0]' || area_id_list === null) && useNative;

//   return useRequest<{
//     list: InfoItem[];
//     pager: Pager;
//   }>({
//     method: 'post',
//     url: `${PATH_PREFIX}/news/newsList`,
//     data: payload.value,
//     useNative: usePrefetch,
//     nativeKey,
//     immediate
//   });
// };

// 地区列表和编码
export const useAreaList = (type?: 'immediate' | 'await' | 'manual') => useRequest<AreaItem[]>({
  method: 'get',
  url: `${PATH_PREFIX}/news/areaList`,
  useNative: true,
  type
});
